var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "relative inline-block text-left" },
      [
        _c("div", [
          _c("span", { staticClass: "rounded-md shadow-sm" }, [
            _c(
              "button",
              {
                staticClass:
                  "inline-flex items-center px-2.5 py-1.5  text-xs leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.isOpen = !_vm.isOpen
                  }
                }
              },
              [_vm._v(" Add tag ")]
            )
          ])
        ]),
        _c(
          "transition",
          {
            attrs: {
              "enter-active-class":
                "transition ease-out duration-100 transform",
              "enter-class": "opacity-0 scale-95",
              "enter-to-class": "opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75 transform",
              "leave-class": "opacity-100 scale-100",
              "leave-to-class": "opacity-0 scale-95"
            }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isOpen,
                    expression: "isOpen"
                  }
                ],
                staticClass:
                  "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg z-10"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "rounded-md bg-white shadow-xs",
                    attrs: {
                      role: "menu",
                      "aria-orientation": "vertical",
                      "aria-labelledby": "options-menu"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "py-1" },
                      _vm._l(_vm.tags, function(tag) {
                        return _c(
                          "a",
                          {
                            key: tag.id,
                            staticClass:
                              "block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900",
                            attrs: { href: "#", role: "menuitem" },
                            on: {
                              click: function($event) {
                                return _vm.onItemClicked(tag.value)
                              }
                            }
                          },
                          [_vm._v(_vm._s(tag.name) + " ")]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "border-t border-gray-100" })
                  ]
                )
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }